import type { ReactNode } from 'react';

export const symbol_calendar_check: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-80q-24 0-42-18t-18-42v-620q0-24 18-42t42-18h65v-28q0-13.6 9-22.8 9-9.2 23.02-9.2t23.5 9.2Q310-861.6 310-848v28h340v-28q0-13.6 9-22.8 9-9.2 23.02-9.2t23.5 9.2Q715-861.6 715-848v28h65q24 0 42 18t18 42v362q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-172H180v430h327q13.08 0 21.54 8.68 8.46 8.67 8.46 21.5 0 12.82-8.62 21.32Q519.75-80 507-80H180Zm0-550h600v-130H180v130Zm0 0v-130 130Zm492 485 154-154q9-9 21-9t21 9.05q9 9.06 9 21.5 0 12.45-9 21.45L693-81q-8.8 9-20.9 9-12.1 0-21.1-9l-88-88q-9-8.8-9-20.9 0-12.1 9.05-21.1 9.06-9 21.5-9 12.45 0 21.45 9l66 66Z"
		/>
	</svg>
);
